import React, { useState, useEffect } from 'react';
import { IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { Delete, Edit } from "@material-ui/icons";
import EnhancedTableHead from "../../EnhancedTableHead";
import './TabStyles.css';
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from 'react-redux';
import { getAllInvestigationActionsEnum } from '../../../../store/action/investigationAction';

const useStyles = makeStyles(() => ({
    editBtn: {
        width: '38px',
        height: '32px',
        borderRadius: '6px',
        backgroundColor: 'rgba(229, 255, 242, 1)',
        border: 'none',
        lineHeight: '18px',
        marginLeft: '5px',
        color: 'rgba(50, 168, 124, 1)',
    },
    deleteBtn: {
        width: '38px',
        height: '32px',
        borderRadius: '6px',
        backgroundColor: 'rgba(255, 229, 229, 1)',
        border: 'none',
        lineHeight: '18px',
        marginLeft: '5px',
        color: 'rgba(168, 50, 50, 1)',
    },
    addButton: {
        width: '90px',
        height: '34px',
        borderRadius: '6px',
        background: '#D5E5F2',
        border: 0,
        fontFamily: 'Poppins',
        fontSize: '15px',
        fontWeight: 600,
        lineHeight: '18px',
        color: '#4969B4',
        marginBottom: '30px',
        marginLeft: 'auto',
    },
    annulerStyle: {
        width: '83px',
        height: '36px',
        borderRadius: '5px',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '20px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
        backgroundColor: 'rgba(229, 234, 238, 1)',
        color: 'rgba(128, 128, 143, 1)',
        marginRight: '20px'
    },
    validerStyle: {
        width: '83px',
        height: '36px',
        borderRadius: '5px',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '20px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
        backgroundColor: 'rgba(86, 157, 210, 1)',
        color: 'rgba(255, 255, 255, 1)',
        marginRight: '40px'
    }
}));

const ActivityTab = ({ handlePrevious, handleNext, formData, handleFormChange,readOnly }) => {
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('title');
    const { tasks, taskSummary } = formData;
    const classes = useStyles();
    const dispatch = useDispatch();
    const investigationActions = useSelector((state) => state.investigationActionReducer);
    const today = new Date().toISOString().split('T')[0];

    useEffect(() => {
        dispatch(getAllInvestigationActionsEnum());
    }, [dispatch]);

    const updateTaskSummary = (tasks) => {
        const newSummary = { total: 0, completed: 0, inProgress: 0, notStarted: 0 };

        tasks.forEach(task => {
            newSummary.total++;
            if (task.status === 'Completed') newSummary.completed++;
            if (task.status === 'In Progress') newSummary.inProgress++;
            if (task.status === 'Not Started') newSummary.notStarted++;

        });
        return newSummary;

    };

    const handleAddTask = () => {
        const newTasks = [...tasks, { id: Date.now(), title: '', plannedDate: '', status: '', priority: '' }];
        const newSummary = updateTaskSummary(newTasks);
        handleFormChange({ tasks: newTasks, taskSummary: newSummary });
    };

    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const updatedTasks = tasks.map((task, i) =>
            i === index ? { ...task, [name]: value } : task
        );
        const newSummary = updateTaskSummary(updatedTasks);
        handleFormChange({ tasks: updatedTasks, taskSummary: newSummary });
    };

    const handleDeleteTask = (index) => {
        const newTasks = tasks.filter((_, i) => i !== index);
        const newSummary = updateTaskSummary(newTasks);
        handleFormChange({ tasks: newTasks, taskSummary: newSummary });
    };

    const headRows = [
        { id: "title", align: "left", label: "Tâche Descriptive" },
        { id: "plannedDate", align: "left", label: "Date planifiée" },
        { id: "status", align: "left", label: "Statut" },
        { id: "priority", align: "left", label: "Priorité" },
        { id: "actions", align: "center", label: "Actions" },
    ];

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    return (
        <div className="container">
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <button onClick={handleAddTask} className={classes.addButton} disabled={readOnly}>
                    Ajouter +
                </button>
            </div>
            <div className="task-summary">
                <div>
                    Total Tâches
                    <input type="number" readOnly value={taskSummary.total} style={{ marginLeft: '8px' }} />
                </div>
                <div>
                    Tâche Terminée
                    <input type="number" readOnly value={taskSummary.completed} style={{ marginLeft: '8px' }} />
                </div>
                <div>
                    Tâche en Cours
                    <input type="number" readOnly value={taskSummary.inProgress} style={{ marginLeft: '8px' }} />
                </div>
                <div>
                    Non commencé
                    <input type="number" readOnly value={taskSummary.notStarted} style={{ marginLeft: '8px' }} />
                </div>
            </div>
    
            <TableContainer component={Paper} className="paper">
                <Table className="tableWrapper">
                    <TableHead>
                        <EnhancedTableHead
                            headRows={headRows}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                        />
                    </TableHead>
                    <TableBody>
                        {tasks.map((task, index) => (
                            <TableRow key={task.id}>
                                <TableCell>
                                    <select
                                        name="title"
                                        value={task.title}
                                        onChange={(e) => handleInputChange(index, e)}
                                        className="selectStyle"
                                        disabled={readOnly}
                                    >
                                        <option value="">Sélectionner une action</option>
                                        {investigationActions.investigationActionsEnum.map((option) => (
                                            <option key={option.key} value={option.key}>
                                                {option.actionName}
                                            </option>
                                        ))}
                                    </select>
                                </TableCell>
                                <TableCell>
                                    <input
                                        type="date"
                                        name="plannedDate"
                                        value={task.plannedDate}
                                        onChange={(e) => handleInputChange(index, e)}
                                        min={today}
                                        className="styleInput"
                                        disabled={readOnly}
                                    />
                                </TableCell>
                                <TableCell>
                                    <select
                                        name="status"
                                        value={task.status}
                                        onChange={(e) => handleInputChange(index, e)}
                                        className="selectStyle"
                                        disabled={readOnly}
                                    >
                                        <option value="">Sélectionner</option>
                                        <option value="Not Started">Pas commencé</option>
                                        <option value="In Progress">En cours</option>
                                        <option value="Completed">Terminé</option>
                                    </select>
                                </TableCell>
                                <TableCell>
                                    <select
                                        name="priority"
                                        value={task.priority}
                                        onChange={(e) => handleInputChange(index, e)}
                                        className="selectStyle"
                                        disabled={readOnly}
                                    >
                                        <option value="">Sélectionner</option>
                                        <option value="Low">Faible</option>
                                        <option value="Medium">Moyenne</option>
                                        <option value="High">Élevée</option>
                                    </select>
                                </TableCell>
                                <TableCell style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                    <IconButton
                                        aria-label="edit"
                                        className={classes.editBtn}
                                        disabled={readOnly}
                                    >
                                        <Edit style={{ fontSize: '20px' }} />
                                    </IconButton>
                                    <IconButton
                                        aria-label="delete"
                                        className={classes.deleteBtn}
                                        onClick={() => handleDeleteTask(index)}
                                        disabled={readOnly}
                                    >
                                        <Delete style={{ fontSize: '20px' }} />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
    
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                <button onClick={handlePrevious} className={classes.annulerStyle} disabled={readOnly}>
                    Précédent
                </button>
                <button onClick={handleNext} className={classes.validerStyle} disabled={readOnly}>
                    Suivant
                </button>
            </div>
        </div>
    );
    
};

export default ActivityTab;
